module.exports = __webpack_public_path__ + "static/media/field.bb86a364.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/field.md
// module id = 374
// module chunks = 0